import React from "react";
import useDemandResponseContext from "../../context/useDemandResponseContext.js";
import useAppContextProvider from "../../../AppContext/useAppContextProvider.js";
import { StyledDialog } from "../../../components/StyledComponents/Dialog/Dialog.js";
import {
  H6HeadlineSmall,
  H8TitleMedium,
} from "../../../components/StyledComponents/Typography/Typography.tsx";
import {
  PrimaryButton,
  SecondaryButton,
  StyledIconButton,
  StyledRadio,
  StyledToggleButton,
} from "../../../components/StyledComponents/Buttons/AuradineButtons.js";
import CloseIcon from "@mui/icons-material/Close";
import {
  Autocomplete,
  Backdrop,
  Box,
  DialogActions,
  DialogContent,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import PlaceHolderButton from "../../../components/PlaceHolderButton/PlaceHolderButton.js";
import CheckIcon from "@mui/icons-material/Check";
import {
  StyledFormControl,
  StyledTextField,
  StyledPaper,
  StyledSelect,
} from "../../../components/StyledComponents/Inputs/Inputs.js";
import { useCreateQSE } from "../../queries/useCreateQSE.ts";
import { useAttachQSE } from "../../queries/useAttachQSE.ts";
import { useDeletePowerCurtail } from "../../queries/useDeleteCurtailSched.ts";
import { set } from "lodash";
import { useTheme } from "../../../ThemeContext/ThemeContext.js";

const AddDeleteEventHeader = (props) => {
  const { setOpenDeleteRecurringEventDialog } =
    useDemandResponseContext();
  const { reset } = props;
  return (
    <Box
      display={"flex"}
      flexDirection={"row"}
      justifyContent={"space-between"}
      flexGrow={1}
      padding={"1rem 0"}
    >
      <H6HeadlineSmall>
        Remove recurring event
      </H6HeadlineSmall>
    </Box>
  );
};

const DeleteEventDialog = (props) => {
  const { colors } = useTheme();
  const { refetch: refetchCurtailData } = props;
  const {
    openQSEDialog,
    setOpenQSEDialog,
    siteLists,
    setSiteSelectedName,
    setOpenDeleteRecurringEventDialog,
    openDeleteRecurringEventDialog,
    setEventToDelete,
    siteSelectedName,
    eventIdToDelete,
    setEventModalAnchor,
  } = useDemandResponseContext();
  const { setToastMessage, setToastOpen } =
    useAppContextProvider();
  const {
    watch,
    handleSubmit,
    control,
    setValue,
    formState: { errors, isValid },
    reset,
    clearErrors,
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    shouldUnregister: false,
    defaultValues: {
      deletionEventType: "",
    },
  });
  const { mutate: deleteCurtailEvent } =
    useDeletePowerCurtail();

  const onsubmit = async (data) => {
    setEventToDelete(data.deletionEventType);
    deleteCurtailEvent(
      {
        id: eventIdToDelete,
        siteName: siteSelectedName,
        deleteType: data.deletionEventType,
      },
      {
        onSuccess: async (data) => {
          if (data?.status === "ok") {
            setToastMessage(
              "Curtail event deleted successfully. Please check the Job Results page or check the jobs column for each miner in the miner inventory tab "
            );
            setToastOpen(true);
            await refetchCurtailData();
            setOpenDeleteRecurringEventDialog(false);
            setEventModalAnchor(null);
            reset();
          } else {
            setToastMessage(
              "Curtail event deletion failed"
            );
            setToastOpen(true);
            setOpenDeleteRecurringEventDialog(false);
            reset();
            setEventModalAnchor(null);
          }
        },
        onError: (error) => {
          setToastMessage("Curtail event deletion failed");
          setToastOpen(true);
          setOpenDeleteRecurringEventDialog(false);
          reset();
          setEventModalAnchor(null);
        },
      }
    );
    setOpenDeleteRecurringEventDialog(false);
  };

  return (
    <Backdrop open={openDeleteRecurringEventDialog}>
      <StyledDialog
        colors={colors}
        sx={{
          "& .MuiDialog-paper": {
            maxWidth: "20rem",
          },
        }}
        open={openDeleteRecurringEventDialog}
      >
        <AddDeleteEventHeader reset={reset} />
        <form onSubmit={handleSubmit(onsubmit)}>
          <DialogContent
            sx={{
              // maxHeight: "60vh",
              // overflowY: "auto",
              padding: 0,
            }}
          >
            <Box display={"grid"} gridTemplateRows={"auto"}>
              <Controller
                name="deletionEventType"
                control={control}
                rules={{
                  required: "Please select an event type",
                }}
                render={({ field }) => (
                  <StyledFormControl colors={colors} >
                    <RadioGroup
                      {...field}
                      onChange={(e) => {
                        field.onChange(e);
                        // setValue("deletionEventType", e.target.value);
                        // clearErrors("deletionEventType");
                      }}
                    >
                      <FormControlLabel
                        sx={{ color: colors.text.primary }}
                        value="single"
                        control={<StyledRadio colors={colors} />}
                        label="This event"
                      />
                      <FormControlLabel
                        sx={{ color: colors.text.primary }}
                        value="following"
                        control={<StyledRadio colors={colors} />}
                        label="This and following events"
                      />
                      <FormControlLabel
                        sx={{ color: colors.text.primary }}
                        value="all"
                        control={<StyledRadio colors={colors} />}
                        label="All events"
                      />
                    </RadioGroup>
                  </StyledFormControl>
                )}
              />
            </Box>
          </DialogContent>
          <DialogActions sx={{ paddingTop: "1rem" }}>
            <SecondaryButton colors={colors}
              onClick={() =>
                setOpenDeleteRecurringEventDialog(false)
              }
            >
              Cancel
            </SecondaryButton>
            <PrimaryButton colors={colors} type="submit">Ok</PrimaryButton>
          </DialogActions>
        </form>
      </StyledDialog>
    </Backdrop>
  );
};

export default DeleteEventDialog;
